import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      textTransform: 'uppercase',
      borderRadius: theme.shape.borderRadiusSmall,
      padding: theme.spacing(0.625, 1.25, 0.5),
      fontSize: theme.typography.pxToRem(10),
      lineHeight: theme.typography.pxToRem(14),
      fontWeight: theme.typography.fontWeightMedium,
      color: COLORS.gray.black,
      minWidth: 'max-content',
    },
  }),
  { name: 'CustomTag' }
);
